import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

export function Checkbox({ ref, className, label, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root> & { label: string }) {
  return (

    <label className="flex cursor-pointer items-center gap-2 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-25">
      <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
          "peer size-5 shrink-0 rounded-md border border-white transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-orange-500 data-checked:border-orange-500 data-checked:bg-orange-500 data-checked:text-white",
          className,
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className={cn("text-current flex items-center justify-center")}
        >
          <Check className="size-4" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className="text-neutral-400 transition-all peer-data-[state=checked]:text-white">{label}</span>
    </label>
  );
}
